import("./jquery.autocomplete");

export default function ($input, minLength) {

    this.localStorageIdentifier = "LocalSearchHistory";
    this.maxLocalSearchEntries = 14;
    this.inputMinLength = minLength;
    this.$inputElement = $input;

    this.onSearchClick = function ($evt) {
        var query = this.$inputElement.val();
        if (query.length < this.inputMinLength) {
            var autocomplete = this.$inputElement.autocomplete();
            autocomplete.suggestions = this.getSearchEntries();
            autocomplete.suggest();
        }
    }.bind(this);

    this.getSearchEntries = function () {
        if (typeof c.storage != "undefined") {
            var entries = c.storage.get(this.localStorageIdentifier).value;
            if (typeof entries == "undefined") {
                return [];
            }
            return entries.entries;
        } else {
            return [];
        }
    }.bind(this);

    this.addSearchEntryFromString = function (searchString) {
        var storageEntry = {
            type: "string",
            value: "",
            data: {
                string: ""
            }
        };
        storageEntry.data.string = searchString;
        storageEntry.value = searchString;
        this._saveSearchEntry(storageEntry);

    }.bind(this);
    this.addSearchEntryFromSuggest = function (suggestion) {
        var storageEntry = {
            type: "suggest",
            value: "",
            data: {
                Path: ""
            }
        };
        storageEntry.value = suggestion.value;
        storageEntry.data.Path = suggestion.data.Path;
        this._saveSearchEntry(storageEntry);
    }.bind(this);

    this._saveSearchEntry = function (newStorageEntry) {
        var storageDataEntries = c.storage.get(this.localStorageIdentifier).value;
        if (typeof storageDataEntries == "undefined") {
            this._initStorage();
            storageDataEntries = {count: 0, entries: []};
        }
        if (storageDataEntries.count >= this.maxLocalSearchEntries) {
            storageDataEntries.entries = storageDataEntries.entries.filter(function (_, idx, arr) {
                return idx > arr.length - this.maxLocalSearchEntries;
            }, this);
            storageDataEntries.count = this.maxLocalSearchEntries - 1;
        }
        storageDataEntries.entries.push(newStorageEntry);
        storageDataEntries.count++;
        c.storage.set(this.localStorageIdentifier, storageDataEntries, false);
    };

    this._initStorage = function () {
        c.storage.set(this.localStorageIdentifier, {count: 0, entries: []}, false);
    };

    this.onFormSubmit = function () {
        var query = this.$inputElement.val();
        if (query != "") {
            this.addSearchEntryFromString(query);
        }
    }.bind(this);

    this.$inputElement.on("click", this.onSearchClick);
    this.$inputElement.closest("form").on("submit", this.onFormSubmit);

};
